import getKnowledgeBaseArticleService from './knowledge-base-article';
export const knowledgeBaseArticleService = getKnowledgeBaseArticleService();
export const services = [knowledgeBaseArticleService.service];
